import script from "./QuizzJustification.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizzJustification.vue?vue&type=script&setup=true&lang=ts"

import "./QuizzJustification.vue?vue&type=style&index=0&id=c290659c&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c290659c"]])

export default __exports__